import { ReasonWiseDowntimeModel } from "./reason-wise-downtime.model";


export class LineDowntimeModel {
    lineId: string;
    lineDesc: string;
    reasonWiseDowntimes: ReasonWiseDowntimeModel[]
    constructor( lineId: string, lineDesc: string,
        reasonWiseDowntimes: ReasonWiseDowntimeModel[]) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.reasonWiseDowntimes = reasonWiseDowntimes;
    }
}